import { AUTH_SUCCESS, startCognitoRefresh } from 'JS/actionCreators/authActions';
import { put, select, takeEvery } from 'redux-saga/effects';
import { loadScribes, loadCursors } from 'JS/actionCreators/scribeActions';
import { getImageLibraries } from 'JS/actionCreators/imagesActions';
import { countryRequest } from 'JS/actionCreators/locationActions';

function* authStartup() {
  yield put(loadScribes());
  yield put(getImageLibraries());
  yield put(loadCursors());
  yield put(startCognitoRefresh());

  const country = yield select(({ location }) => location.country);
  if (!country) {
    yield put(countryRequest());
  }
}

export default function* appStartupSagas() {
  yield takeEvery(AUTH_SUCCESS, authStartup);
}
